import { SnackbarProvider } from 'notistack';
import { PropsWithChildren } from 'react';

export function ProvideSnackbar({ children }: PropsWithChildren<{}>) {
    return <SnackbarProvider dense>{children}</SnackbarProvider>;
}
